import FooterPage from "../components/Custom/Footer/FooterPage";
import Navbar from "../components/Custom/Navbar/Navbar";
import WinnersList from "../components/Winners/WinnersList";

export default function Winners() {
  return (
    <>
      <Navbar />
      <WinnersList />
      <FooterPage />
    </>
  );
}
